<script>
export default {
  data: () => ({
    tabShow: false,
        tabGlide: {
        left: 0,
          top: 0,
          width: 0,
          height: 0
    },
  }),
  methods: {
    setTabActive(newValue) {
      this.tabShow = newValue;
      let tabItem = this.$refs[newValue];
      let relativePosition = this.getPositionRelativeToParent(tabItem);
      this.tabGlide.left = relativePosition.left + "px";
      this.tabGlide.top = relativePosition.top + "px";
      this.tabGlide.width = tabItem.offsetWidth + "px";
      this.tabGlide.height = tabItem.offsetHeight + "px";
    },
    getPositionRelativeToParent(element) {
      var parent = element.parentElement;
      var parentRect = parent === null || parent === void 0 ? void 0 : parent.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();
      return {
        left: elementRect.left - parentRect.left,
        top: elementRect.top - parentRect.top
      };
    },
  }
}
</script>